var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-md-12" },
    [
      _c(
        "time-line",
        [
          _c(
            "time-line-item",
            {
              staticClass: "timeline-inverted",
              attrs: { badgeType: "danger", badgeIcon: "ti-gallery" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "label label-danger",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_vm._v("Some title")]
              ),
              _c("p", { attrs: { slot: "body" }, slot: "body" }, [
                _vm._v(
                  " Wifey made the best Father's Day meal ever. So thankful so happy so blessed. Thank you for making my family We just had fun with the “future” theme !!! It was a fun night all together ... The always rude Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in downtown."
                ),
              ]),
              _c("h6", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("i", { staticClass: "ti-time" }),
                _vm._v(" 11 hours ago via Twitter "),
              ]),
            ]
          ),
          _c(
            "time-line-item",
            { attrs: { badgeType: "success", badgeIcon: "ti-check-box" } },
            [
              _c(
                "span",
                {
                  staticClass: "label label-success",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_vm._v("Another Title")]
              ),
              _c("p", { attrs: { slot: "body" }, slot: "body" }, [
                _vm._v(
                  " Thank God for the support of my wife and real friends. I also wanted to point out that it’s the first album to go number 1 off of streaming!!! I love you Ellen and also my number one design rule of anything I do from shoes to music to homes is that Kim has to like it...."
                ),
              ]),
            ]
          ),
          _c(
            "time-line-item",
            {
              staticClass: "timeline-inverted",
              attrs: { badgeType: "info", badgeIcon: "ti-credit-card" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "label label-success",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_vm._v("Another Title")]
              ),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c("p", [
                    _vm._v(
                      " Called I Miss the Old Kanye That’s all it was Kanye And I love you like Kanye loves Kanye Famous viewing @ Figueroa and 12th in downtown LA 11:10PM"
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " What if Kanye made a song about Kanye Royère doesn't make a Polar bear bed but the Polar bear couch is my favorite piece of furniture we own It wasn’t any Kanyes Set on his goals Kanye"
                    ),
                  ]),
                  _c("hr"),
                  _c("drop-down", { staticClass: "btn-group" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-info dropdown-toggle",
                        attrs: {
                          slot: "title",
                          href: "#",
                          type: "button",
                          "data-toggle": "dropdown",
                        },
                        slot: "title",
                      },
                      [
                        _c("i", { staticClass: "ti-settings" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "caret" }),
                      ]
                    ),
                    _c("li", [
                      _c("a", { attrs: { href: "#action" } }, [
                        _vm._v("Action"),
                      ]),
                    ]),
                    _c("li", [
                      _c("a", { attrs: { href: "#action" } }, [
                        _vm._v("Another action"),
                      ]),
                    ]),
                    _c("li", [
                      _c("a", { attrs: { href: "#here" } }, [
                        _vm._v("Something else here"),
                      ]),
                    ]),
                    _c("li", { staticClass: "divider" }),
                    _c("li", [
                      _c("a", { attrs: { href: "#link" } }, [
                        _vm._v("Separated link"),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ]
          ),
          _c(
            "time-line-item",
            { attrs: { badgeType: "warning", badgeIcon: "ti-gallery" } },
            [
              _c(
                "span",
                {
                  staticClass: "label label-warning",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_vm._v("Another Title")]
              ),
              _c("p", { attrs: { slot: "body" }, slot: "body" }, [
                _vm._v(
                  " Tune into Big Boy's 92.3 I'm about to play the first single from Cruel Winter Tune into Big Boy's 92.3 I'm about to play the first single from Cruel Winter also to Kim’s hair and makeup Lorraine jewelry and the whole style squad at Balmain and the Yeezy team. Thank you Anna for the invite thank you to the whole Vogue team"
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }